import { createContext } from "react";
export const DropdownContext = createContext(null);
//# sourceMappingURL=context.js.map